import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-fluid formgrid grid" }
const _hoisted_2 = { class: "field col-12 lg:col-7" }
const _hoisted_3 = { class: "field col-12 lg:col-3" }
const _hoisted_4 = { class: "field col-12 lg:col-2 text-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block"} }, " ", -1)
const _hoisted_6 = {
  key: 0,
  class: "col-12"
}
const _hoisted_7 = {
  key: 1,
  class: "field col-12 text-right"
}
const _hoisted_8 = {
  key: 2,
  class: "col-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"])),
    onKeydown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleKeydown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statCompanyStorage.company")), 1),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.companyId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyId) = $event)),
          options: _ctx.companies,
          onChange: _ctx.dataChanged,
          optionLabel: "name",
          optionValue: "id",
          placeholder: "-"
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statCompanyStorage.date")), 1),
        _createVNode(_component_Calendar, {
          modelValue: _ctx.date,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date) = $event)),
          yearRange: '2022:2100',
          minDate: new Date('01/01/2022'),
          maxDate: new Date(),
          showIcon: true,
          onDateSelect: _ctx.dataChanged
        }, null, 8, ["modelValue", "minDate", "maxDate", "onDateSelect"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Button, {
          label: _ctx.t('buttons.search'),
          icon: "pi pi-search",
          type: "submit",
          class: "p-button-primary p-uppercase"
        }, null, 8, ["label"])
      ]),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Divider)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults && _ctx.results.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Button, {
              label: _ctx.t('buttons.print'),
              icon: "pi pi-print",
              class: "p-button-primary p-uppercase",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printReport()))
            }, null, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_DataTable, {
              dataKey: "id",
              responsiveLayout: "scroll",
              showGridlines: "",
              sortField: "code",
              sortOrder: 1,
              stripedRows: "",
              value: _ctx.results
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
              ]),
              loading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.loading")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "code",
                  header: _ctx.t('statCompanyStorage.code')
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(data[field] ? data[field] : "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "quantity",
                  header: _ctx.t('statCompanyStorage.totalQuantity'),
                  bodyClass: "text-center",
                  headerStyle: "width: 10%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(data[field] ? _ctx.n(data[field], "number0") : "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parcelTypes, (parcelType) => {
                  return (_openBlock(), _createBlock(_component_Column, {
                    field: "parcelTypesQuantity",
                    header: parcelType.name,
                    key: parcelType.id,
                    bodyClass: "text-center",
                    headerStyle: "width: 10%"
                  }, {
                    body: _withCtx(({ data, field }) => [
                      _createTextVNode(_toDisplayString(data[field] && data[field][parcelType.id] ? _ctx.n(data[field][parcelType.id], "number0") : "0"), 1)
                    ]),
                    _: 2
                  }, 1032, ["header"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}